import { trackingEvent } from '../../../../utils';
import { CLICK_EVENT_ACTION_TYPE, CLICK_EVENT_TRIGGER, DEALER_ACTIONS_ACTION_CATEGORY } from '../../../../constants';

const {
  zipCodeEndpoint,
  getDealer,
  contactDealer,
  baseMSRP,
  destinationChargeLabel,
  linkView,
  linkViewText,
  zipCodePlaceholder,
  invalidZipCodeText,
  title,
  arrowNext,
  arrowPrev,
  closeTooltip,
  mileLabel,
  searchRange,
  apiErrorMessage,
  powerhouseLogo,
  loading,
  tbdPrice,
  tbdString,
  contactDealerPageUrl,
  segment,
  category,
  family,
  models,
} = window.HONDA_INVENTORY_NEAR_YOU;

export const MAPPING = {
  zipCodeEndpoint,
  getDealer,
  contactDealer,
  baseMSRP,
  destinationChargeLabel,
  linkView,
  linkViewText,
  zipCodePlaceholder,
  invalidZipCodeText,
  title,
  arrowNext,
  arrowPrev,
  closeTooltip,
  mileLabel,
  searchRange,
  apiErrorMessage,
  powerhouseLogo,
  loading,
  tbdPrice,
  tbdString,
  contactDealerPageUrl,
  segment,
  category,
  family,
  models,
};

export const generateInventoryUrl = (zipCode) => linkView.concat(`&zip=${zipCode}`);

export const trackingEventGeneralClick = (eventLabel, dealer, href = '') => {
  // tracking
  let address = `${dealer.DA || ''}`;
  address += dealer.DC ? `. ${dealer.DC}` : '';
  address += dealer.DS ? `, ${dealer.DS}` : '';
  trackingEvent({
    event: CLICK_EVENT_TRIGGER,
    type: CLICK_EVENT_ACTION_TYPE,
    label: `${window.pageName}:${eventLabel}`,
    category: DEALER_ACTIONS_ACTION_CATEGORY,
    custom: {
      dealer: {
        // eslint-disable-next-line camelcase
        selected_dealer_zipcode: dealer.DZ.toLowerCase(),
        // eslint-disable-next-line camelcase
        selected_dealer_name: dealer.DN.toLowerCase(),
        // eslint-disable-next-line camelcase
        selected_dealer_address: address.toLowerCase(),
        // eslint-disable-next-line camelcase
        selected_dealer_phone_number: dealer.DP,
        // eslint-disable-next-line camelcase
        dealer_id: dealer.DID,
      },
      // eslint-disable-next-line camelcase
      link_metadata: {
        // eslint-disable-next-line camelcase
        destination_url: '',
      },
      metadata: {
        // eslint-disable-next-line camelcase
        target_url: href,
      },
    },
  });
};